import { AuctionStatusType, AuctionTypeType } from "@shared/clickar-constants";
import { LotDTO, LotFullDTO } from "@shared/model/lotDTO";
import { TemplateDTO } from "@shared/model/template.model";

export interface CreateAuctionDTO {
	endDate?: Date;
	lots?: LotDTO[];
	startDate?: Date;
	template?: TemplateDTO;
}
export class AuctionDTO {
	auctionName?: string;
	commercialInfoEmail?: string;
	commercialInfoPhone?: string;
	creatorUser?: number;
	description?: string;
	entryPrice?: number;
	idAuction?: number;
	idMarket?: string;
	minOfferNumber?: number;
	purchaseNote?: string;
	reservePrice?: boolean;
	entryPrice1from?: number;
	entryPrice1to?: number;
	entryPrice1?: number;
	entryPrice2from?: number;
	entryPrice2to?: number;
	entryPrice2?: number;
	entryPrice3from?: number;
	entryPrice3to?: number;
	entryPrice3?: number;
	startDate?: Date;
	startTime?: Date;
	/** NOTE: It's not a Date: it's a ISO 8601 string */
	endDate: Date;
	endTime?: Date;
	extraTime?: number;
	minRelaunch?: number;
	auctionMessage?: string;
	largeLogo?: number;
	smallLogo?: number;
	regulation?: number;
	smallLogoBlob: any;
	status: AuctionStatusType;
	flgAward: boolean;
	provenances: string[];
	idTemplate: number;
	idDealer: number;
	productType: string;
	flgMultiAuctioneer: boolean;
	auctionType: AuctionTypeType;
	awardEmail: string;
	idFileMessage: number;
	lotCount: number;
	entryClickbuyPrice1?: number;
	entryClickbuyPrice2?: number;
	entryClickbuyPrice3?: number;
	entryClickbuyPrice1from?: number;
	entryClickbuyPrice2from?: number;
	entryClickbuyPrice3from?: number;
	entryClickbuyPrice1to?: number;
	entryClickbuyPrice2to?: number;
	entryClickbuyPrice3to?: number;
}
export interface AuctionFullDTO {
	auctionDTO?: AuctionDTO;
	lotFullDTO?: LotFullDTO[];
}

export interface ObservedAuctionDTO {
	auctionDTO: AuctionDTO;
	lotFullDTO?: LotFullDTO[];
}

export interface OfferResponseDTO {
	accepted?: boolean;
	responseType?: string;
	notHigherReserve?: boolean;
	errorCode?: string;
	basePrice?: number;
}

export interface AuctionDateDTO {
	idTemplate: number;
	startDate: Date;
	endDate: Date;
}

export interface PortalInfoDTO {
	awardedVehicleMonth?: number;
	monthAuctions?: number;
	totalVehicleAwarded?: number;
	users?: number;
}

export interface TableData {
	rowsOnPage?: number;
	orderBy?: string;
	sortOrder: "desc" | "asc";
	offset?: number;
	limit?: number;
	col?: number;
	mfActivePage?: number;
	queries?: { [key: string]: string }
};